var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../../services/AxiosClients";
const ABSENT = 1;
const PRESENT = 2;
const UNKNOWN = 3;
const TARDY = 4;
const EXCUSED = 5;
const ENTRY = 6;
const NO_ENTRY = 7;
export default class TranscriptCourseAttendanceStatusService {
    static getTranscriptCourseAttendanceStatuses(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/transcriptCourseAttendanceStatuses/search/findByNameLike", {
                params: { search },
            });
            return response.data._embedded.transcriptCourseAttendanceStatuses;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/transcriptCourseAttendanceStatuses/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.transcriptCourseAttendanceStatuses;
        });
    }
    static get AbsentId() {
        return ABSENT;
    }
    static get PresentId() {
        return PRESENT;
    }
    static get UnknownId() {
        return UNKNOWN;
    }
    static get TardyId() {
        return TARDY;
    }
    static get ExcusedId() {
        return EXCUSED;
    }
    static get EntryId() {
        return ENTRY;
    }
    static get NoEntryId() {
        return NO_ENTRY;
    }
}
